import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { concat } from "@ember/helper";
import { action } from "@ember/object";
import UppyImageUploader from "discourse/components/uppy-image-uploader";
export default class FKControlImage extends Component {
    static controlType = "image";
    @action
    setImage(upload1) {
        this.args.field.set(upload1);
    }
    @action
    removeImage() {
        this.setImage(undefined);
    }
    static{
        template(`
    <UppyImageUploader
      @id={{concat @field.id "-" @field.name}}
      @imageUrl={{readonly @value}}
      @onUploadDone={{this.setImage}}
      @onUploadDeleted={{this.removeImage}}
      class="form-kit__control-image no-repeat contain-image"
    />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
